
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car-parts-black-friday-deals-2025",
      function () {
        return require("private-next-pages/car-parts-black-friday-deals-2025/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/car-parts-black-friday-deals-2025"])
      });
    }
  